import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { DeleteInformationAboutResearchers } from "../../../../Redux/Reducers/Submitter/InformationAboutResearchers";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import loadConfig from "../../../../Services/Api/ApiServices";
import TableAHSF from "../../../../Components/TableAHSF";
import PopupAHSF from "../../../../Components/PopupAHSF";
import AddEditePublished from "./AddEditePublished";
import { DeleteSU_NT_MRI_PublishedSientificResearch } from "../../../../Redux/Reducers/Submitter/PublishedScientificRes";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";

const PublishedScientificResearch = (props) => {
  const [jsonData, setJsonData] = useState({});
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [InfoAboutResearcherId, setInfoAboutResearcherId] = useState(null);
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);

  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  //   const shouldDisableFields = !(
  //     //[,]
  //     // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "reference",
      ShowStatus: true,
      NmaeColumn: "المرجع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "link",
      ShowStatus: true,
      NmaeColumn: "الرابط",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setInfoAboutResearcherId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !props.shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteSU_NT_MRI_PublishedSientificResearch(e.target.value)
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: !props.shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>{<AddEditePublished />}</div>,
    title: "الابحاث العلمية المنشورة ",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditePublished
          publishedSientificResearchId={InfoAboutResearcherId}
          canEdit="edit"
          shouldDisableFields={props.shouldDisableFields}
        />
      </div>
    ),
    title: "الابحاث العلمية المنشورة ",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  return (
    ActiveRound?<>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"publishedSientificResearchId"}
        valueButtonAction={"publishedSientificResearchId"}
        URL={`api/SU_NT_MRI_PublishedSientificResearch/GetSU_NT_MRI_PublishedSientificResearchList`}
        UrlBody={{
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            props.applicationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.shouldDisableFields}
        
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        fileStoreName={"CVDocumentAttachment"}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={" "}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>:""
  );
};

export default PublishedScientificResearch;
